import { CookieCategory } from '@amzn/awscat-cookie-management';

import { GetLocalStorage, SetLocalStorage } from '../contexts/CookieConsentContext';

const waveCapacityStorageKey = 'applicationGrouping:waveCapacity';

export interface WaveCapacity {
    applications: number;
    databases: number;
    servers: number;
}

export interface ApplicationGroupingWaveCapacity {
    [portfolioId: string]: WaveCapacity;
}

class ApplicationGroupingLocalStorage {

    public static getCapacity(portfolioId: string, getLocalStorage: GetLocalStorage): WaveCapacity | null {
        const waveCapacityValue = this.getWaveCapacityValue(getLocalStorage);
        return waveCapacityValue?.[portfolioId] ?? null;
    } 

    private static getWaveCapacityValue(getLocalStorage: GetLocalStorage): ApplicationGroupingWaveCapacity | null {
        try {
            const waveCapacityValue: string = getLocalStorage(`${waveCapacityStorageKey}`, [CookieCategory.Functional]);
            if (waveCapacityValue) {
                const waveCapacity: ApplicationGroupingWaveCapacity = JSON.parse(waveCapacityValue);
                return waveCapacity;
            }
        } catch (err) {
            console.log(err);
        }
        return null;
    }

    public static saveWaveCapacity(
        portfolioId: string, waveCapacity: WaveCapacity, getLocalStorage: GetLocalStorage, setLocalStorage: SetLocalStorage
    ): void {
        const currentWaveCapacity = this.getWaveCapacityValue(getLocalStorage) ?? {};
        currentWaveCapacity[portfolioId] = waveCapacity;
        // Cannot use JSONConverter serializer because the value of this localStorage has no fixed key,
        // instead the keys are portfolio IDs, and are not recognized and therefore ignored when mapping JSON
        const str = JSON.stringify(currentWaveCapacity);
        setLocalStorage(`${waveCapacityStorageKey}`, str, [CookieCategory.Functional]);
    }
}

export default ApplicationGroupingLocalStorage;
